<script>
	// NPM Modules
	import dayjs from 'dayjs';
	// Stores
	import MeetingStore from '@/Stores/Racing/MeetingStore.js';
	import RaceStore from '@/Stores/Racing/RaceStore.js';
	import { editDeductionsOpen } from '@/Stores/Store.js';
	// Partials
	import ManageRace from '@/Partials/Racing/Race/ManageRace.svelte';
	import EditDeductions from '@/Partials/Racing/Selections/_EditDeductions.svelte';
	import ManualReview from '@/Partials/Racing/Race/_UpdateManualReview.svelte';
	import ManualResultButton from '@/Partials/Racing/Results/ManualResultButton.svelte';
	import ManualResultForm from '@/Partials/Racing/Results/ManualResultForm.svelte';
	import PromotionButton from '@/Partials/Promotions/PromotionButton.svelte';
	// Components
	import Label from '@/Components/Label.svelte';
	import Prompt from '@/Components/Prompt.svelte';
	// Constants
	import { EventStatus } from '@/Constants/Event.js';
	import { PromotionsType } from '@/Constants/Promotions.js';

	export let selectedMeetingId;
	export let selectedRaceId;

	$: meeting = selectedMeetingId && $MeetingStore.firstWhere('id', selectedMeetingId);
	$: race = meeting && selectedRaceId && $RaceStore.firstWhere('id', selectedRaceId);
	$: canBeUnfinalised = race && dayjs().diff(dayjs(race.start_time), 'hour') < 48; //The race is within 48 hours of starting

	let manageRaceOpen = false;
	let promptUnfinalise = false;
</script>

{#if race}
	<Prompt
		bind:open={promptUnfinalise}
		title="Confirm unfinalising race"
		message="Unfinalising will require you to enter results manually to process any bets. Are you sure you want to unfinalise this race?"
		onConfirm={() => RaceStore.markRaceUnfinalised(race.id)}
	/>
	<Prompt
		bind:open={promptUnfinalise}
		title="Confirm unfinalising race"
		onConfirm={() => RaceStore.markRaceUnfinalised(race.id)}
	>
		<div class="m-3">
			<span class="text-xl">
				This will un-result all the bets already placed and cancel withdrawals, and will require you to enter results
				manually to process any bets, only do this when you have received incorrect results
			</span>
			<br />
			<br />
			<span class="font-semibold text-xl">Are you sure you want to unfinalise the race?</span>
		</div>
	</Prompt>
	<ManageRace bind:open={manageRaceOpen} {meeting} {race} />
	<EditDeductions {meeting} {race} />
	<ManualResultForm {meeting} {race} />
	<div class="flex items-end w-full mb-2 space-x-2">
		{#if race.featured}
			<Label label="Featured Race" classes="mb-1" />
		{/if}
		<button
			on:click={() => (manageRaceOpen = true)}
			title="Edit Race Classification/Bet Products"
			class="flex items-center p-1 border rounded-md focus:outline-none bg-gray-300 text-dark"
		>
			<span class="mr-1">{race.classification ? race.classification.name.toUpperCase() : 'Unclassified'}</span>
		</button>
		{#if [EventStatus.Open, EventStatus.ReOpened, EventStatus.Abandoned].indexOf(race.status.id) === -1 && !race.unfinalised && canBeUnfinalised}
			<button
				on:click={() => {
					promptUnfinalise = true;
				}}
				title="Unfinalise Race"
				class="flex items-center p-1 rounded-md focus:outline-none bg-orange-500 text-white"
			>
				<span class="mr-1">Unfinalise Race</span>
			</button>
		{/if}
		{#if [EventStatus.Paid, EventStatus.Abandoned].indexOf(race.status.id) === -1 || race.unfinalised}
			<ManualReview {race} />
			{#if race.in_review}
				<button
					on:click={() => editDeductionsOpen.set(true)}
					title="Edit Deductions"
					class="flex items-center p-1 border rounded-md focus:outline-none bg-gray-300 text-dark"
				>
					<span class="mr-1">Edit Deductions</span>
				</button>
			{/if}
			<ManualResultButton {race} />
		{/if}
		<PromotionButton
			event={race}
			{meeting}
			promotionTypes={[
				PromotionsType.RacingBonusBack,
				PromotionsType.RacingCashBack,
				PromotionsType.SRMBonusBack,
				PromotionsType.SRMCashBack
			]}
			permission="races.update.money_back_promotion"
		/>
	</div>
{/if}
